
import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useNavigate } from 'react-router-dom';
import { Article } from '@/hooks/journalist/types';
import EmptyState from './EmptyState';

interface ArticleTableProps {
  articles: Article[];
  emptyMessage?: string;
}

const ArticleTable: React.FC<ArticleTableProps> = ({ 
  articles, 
  emptyMessage = "No articles found matching your criteria." 
}) => {
  const navigate = useNavigate();
  
  const handleRowClick = (articleId: string) => {
    navigate(`/article/${articleId}`);
  };
  
  if (articles.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }
  
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Title</TableHead>
          <TableHead>Category</TableHead>
          <TableHead>Date</TableHead>
          <TableHead>Read Time</TableHead>
          <TableHead>Type</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {articles.map(article => (
          <TableRow 
            key={article.id} 
            className="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800"
            onClick={() => handleRowClick(article.id)}
          >
            <TableCell className="font-medium">{article.title}</TableCell>
            <TableCell>{article.category}</TableCell>
            <TableCell>{article.date}</TableCell>
            <TableCell>{article.readTime} min</TableCell>
            <TableCell>
              {article.premium ? (
                <Badge variant="secondary">Premium</Badge>
              ) : (
                <Badge variant="outline">Free</Badge>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ArticleTable;
